import { NavbarNew, SidebarNew } from "../components/Navigation"
import Header from "../components/Header"
import blog from "./../styles/blog.module.css"
import cx from "classnames"
import { Link } from "react-router-dom"
import Footer from "../components/Footer"

export default function Blog() {
    return (
        <>
            <NavbarNew/>
            <SidebarNew/>
            <Header routeName="blog" altName="Pecera" titleText="BLOG"/>

            {/* CONTENIDO */}
            <div className={ cx(blog.section, 'section') }>
                <div className={ cx(blog.content, 'content') }>
                    <div className={ cx(blog.blog_title) }>SUMÉRGETE EN EL MUNDO DEL GRAN ACUARIO</div>
                    <div className={ cx(blog.blog_des) }>Descubre todo lo que sucede dentro del acuario: nuevas especies, proyectos, experiencias y aprendizajes que nos conectan con el océano.</div>
                    <div className={ cx(blog.blog_sep) }></div>
                    
                    <div className={ cx(blog.elementos) }>
                        <div className={ cx(blog.elementos_entrada) }>
                            <div className={ cx(blog.elementos_entrada_img) }>
                                <img src="/images/blog/carnaval2026/front.png" srcSet="/images/blog/carnaval2026/front.webp" alt="Carnaval Mazatlán 2026" title="Carnaval Mazatlán 2026" />
                            </div>
                            <div className={ cx(blog.elementos_entrada_des) }>
                                <div className={ cx(blog.elementos_entrada_des_title) }>El Gran Acuario celebra la diversidad cultural con “Los 5 Carnavales del Mundo”</div>
                                <div className={ cx(blog.elementos_entrada_des_date) }>Febrero 01, 2026</div>
                                <div className={ cx(blog.elementos_entrada_des_des) }>Hoy el Gran Acuario Mazatlán se viste de fiesta, música y color para invitar a sus visitantes a vivir un viaje extraordinario a través de “Los 5 Carnavales del Mundo”, una experiencia que celebra la alegría, la diversidad cultural y la pasión que distingue a una de las fiestas más grandes del planeta...</div>
                                <Link to="/blog/carnaval2026" className={ cx(blog.elementos_entrada_des_btn) }>Leer más</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer/>
        </>
    )
}